const TOKEN_KEY = "TOKEN_KEY";
const USERNAME = "USERNAME";
const NAME = "NAME";
const ROLE = "ROLE";
const URL_LOGIN = "URL_LOGIN";
const EXPIRED_TOKEN_TIME = 1;
import { ROLE_ENUMS } from "@/common/auth.const.js";
import Cookies from "js-cookie";

// TOKEN

export const saveToken = (token) => {
  Cookies.set(TOKEN_KEY, token, { expires: EXPIRED_TOKEN_TIME });
};

export const getToken = () => {
  return Cookies.get(TOKEN_KEY) || "";
};

export const destroyToken = () => {
  Cookies.remove(TOKEN_KEY);
};

// USERNAME

export const saveUsername = (username) => {
  Cookies.set(USERNAME, username, { expires: EXPIRED_TOKEN_TIME });
};

export const getUsername = () => {
  return Cookies.get(USERNAME);
};

export const destroyUsername = () => {
  Cookies.remove(USERNAME);
};

// NAME

export const saveName = (name) => {
  Cookies.set(NAME, name, { expires: EXPIRED_TOKEN_TIME });
};

export const getName = () => {
  return Cookies.get(NAME);
};

export const destroyName = () => {
  Cookies.remove(NAME);
};

// ROLE
export const saveRole = (role) => {
  Cookies.set(ROLE, role, { expires: EXPIRED_TOKEN_TIME });
};

export const getRole = () => {
  return Cookies.get(ROLE);
};

export const destroyRole = () => {
  Cookies.remove(ROLE);
};

// URL_LOGIN
export const saveUrlLogin = (urlLogin) => {
  window.localStorage.setItem(URL_LOGIN, urlLogin);
};

export const getUrlLogin = () => {
  return window.localStorage.getItem(URL_LOGIN);
};

export const destroyUrlLogin = () => {
  window.localStorage.removeItem(URL_LOGIN);
};

export const isAdmin = () => {
  return [
    ROLE_ENUMS.ADMIN.ROLE_CODE,
  ].includes(Cookies.get(ROLE));
};

export const isLogged = () => {
  return !!getToken() && !!getUsername() && !!getName() && !!getRole();
};

// Cookies Common
export const saveCookie = (name, value) => {
  Cookies.set(name, value, { expires: EXPIRED_TOKEN_TIME });
};

export const getCookie = (name) => {
  return Cookies.get(name);
};

export const deleteCookie = (name) => {
  Cookies.remove(name);
};

export default {
  saveToken,
  getToken,
  destroyToken,
  saveUsername,
  getUsername,
  destroyUsername,
  saveName,
  getName,
  destroyName,
  saveRole,
  getRole,
  destroyRole,
  isAdmin,
  isLogged,
  saveUrlLogin,
  getUrlLogin,
  destroyUrlLogin,
  saveCookie,
  getCookie,
  deleteCookie,
};
